import { SidekickSupportedTms } from '@shared/generated/graphql';
import { SupportedEntityType, TMSPageInfo } from './types';

export function getLoadStopPageInfo(
  dom: string,
  domIframe: string
): TMSPageInfo {
  const domContent = dom ?? domIframe;

  return {
    pageType: 'tms',
    tms: SidekickSupportedTms.LOADSTOP,
    entityInfo: getEntityInfo(domContent),
  };
}

const getEntityInfo = (domIframe: string) => {
  const loadRefPattern: RegExp =
    /<span[^>]*id=["']LoadRefNumberSpan["'][^>]*>(\d+)<\/span>/;
  const loadRefMatch: RegExpMatchArray | null = domIframe.match(loadRefPattern);

  if (loadRefMatch) {
    return [
      {
        entityType: SupportedEntityType.SHIPMENT,
        entityReference: loadRefMatch[1],
      },
    ];
  }

  return [];
};
